type IotDeviceAnalysisIconProps = {
  color?: string;
  size?: number;
}

export const IotDeviceAnalysisIcon = ({ color = '#363BC4', size = 32 }: IotDeviceAnalysisIconProps): JSX.Element => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* chip body */}
    <rect x="5" y="5" width="14" height="14" rx="2" stroke={color} strokeWidth="1.6" />
    {/* corner screws */}
    <circle cx="7.2" cy="7.2" r="0.6" fill={color} />
    <circle cx="16.8" cy="7.2" r="0.6" fill={color} />
    <circle cx="7.2" cy="16.8" r="0.6" fill={color} />
    <circle cx="16.8" cy="16.8" r="0.6" fill={color} />
    {/* left connectors */}
    <line x1="5" y1="9.5" x2="2.5" y2="9.5" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
    <line x1="5" y1="14.5" x2="2.5" y2="14.5" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
    {/* right connectors */}
    <line x1="19" y1="9.5" x2="21.5" y2="9.5" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
    <line x1="19" y1="14.5" x2="21.5" y2="14.5" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
    {/* top connectors */}
    <line x1="9.5" y1="5" x2="9.5" y2="2.5" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
    <line x1="14.5" y1="5" x2="14.5" y2="2.5" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
    {/* bottom connectors */}
    <line x1="9.5" y1="19" x2="9.5" y2="21.5" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
    <line x1="14.5" y1="19" x2="14.5" y2="21.5" stroke={color} strokeWidth="1.4" strokeLinecap="round" />
    {/* center asterisk */}
    <line x1="12" y1="9.5" x2="12" y2="14.5" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
    <line x1="9.5" y1="12" x2="14.5" y2="12" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
    <line x1="10.2" y1="10.2" x2="13.8" y2="13.8" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
    <line x1="13.8" y1="10.2" x2="10.2" y2="13.8" stroke={color} strokeWidth="1.2" strokeLinecap="round" />
  </svg>
);
